"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DamagedController_js_1 = require("./DamagedController.js");
exports.DamagedController = DamagedController_js_1.DamagedController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/damaged/controllers/index.ts
// module id = 387
// module chunks = 0